import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { TAXONOMY_NS, UATaxonomyLabels, createTaxonomyLabels } from '../helpers/taxonomyLabels'
import { useUAInsightsMeta } from './useUAInsightsMeta'

export type UATaxonomy = UATaxonomyLabels

/**
 * The feature's display boundary for taxonomy items: resolvers that turn a
 * motivation / story-pattern / tag / dimension / genre reference into a
 * localised label.
 *
 * Safe to call anywhere inside the feature: `/meta` is a boot prerequisite
 * (the provider renders a fatal error without it), and every resolver degrades
 * to the API name or a formatted code rather than throwing when a lookup misses.
 */
export const useUATaxonomy = (): UATaxonomy => {
  const { t } = useTranslation(TAXONOMY_NS)
  const { motivationByCode, dimensionById, dimensionByCode } = useUAInsightsMeta()

  return useMemo(() => createTaxonomyLabels(t, { motivationByCode, dimensionById, dimensionByCode }), [t, motivationByCode, dimensionById, dimensionByCode])
}
